
import Vue from "vue";
import { HTTP } from '@/axios_api/http-common';
import * as XLSX from 'xlsx';
export default Vue.extend({
    props: ["height", "selectedProjectId", "nptOption"],
    data() {
        return {
            nptData: { tableId: '', columns: [] } as { tableId: '', columns: { columnName: string; values: string[] }[] },
            search: "",
            actionFilter: "All",
            categoryFilter: "All",
            fields: [
                { key: 'Name', label: 'NPT Name' },
                { key: 'Time', label: 'NPT Time (days)', class: 'text-center' },
            ],
        }
    },
    computed: {
        computedTableData(): Array<any> {
            if (this.nptData.columns.length) {
                let arr = [];
                for (let i = 0; i < this.nptData.columns[0].values.length; i++) {
                    // if (i === 0) continue;
                    arr.push({
                        Name: this.nptData.columns[0].values[i],
                        Time: this.nptData.columns[1].values[i],
                    })
                }
                return arr
            }

            return []
        },

        getHeader(): string {
            return "NPT Table for " + this.getProjectNameFromId(this.selectedProjectId)
        }
    },
    methods: {
        exportToExcel() {
            const exportData = this.computedTableData.map(row => ({
                "NPT Name": row.Name,
                "NPT Time (Days)": row.Time
            }));

            const ws = XLSX.utils.json_to_sheet(exportData);

            // Calculate column widths based on data
            type ExportDataKey = "NPT Name" | "NPT Time (Days)";
            const columnWidths = Object.keys(exportData[0] || {}).map(key => {
                const typedKey = key as ExportDataKey;
                const maxLength = Math.max(
                key.length,
                ...exportData.map(row => (row[typedKey] ? String(row[typedKey]).length : 0))
                );
                return { wch: maxLength + 2 }; // Add some padding
            });

            // Apply column width
            ws['!cols'] = columnWidths;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "NPT Table");

            const fileName = `NPT_Table_${this.getProjectNameFromId(this.selectedProjectId)}.xlsx`;
            XLSX.writeFile(wb, fileName);
        },
        fetchData() {
            HTTP.get(`analytics/query/nptvstime/?projectId=${this.selectedProjectId}&option=${this.nptOption}`)
                .then((response: any) => {
                    this.nptData = response.data.data
                })
                .catch((error: any) => {

                })
        },

        getProjectNameFromId(id: any) {
            const project = this.$store.getters["projectModule/getProjectById"](id);
            return project && project.name ? project.name : "";
        },
    },
    mounted() {
        this.fetchData()
    },
    watch: {
        activityTimeData: {
            handler() {
                if (!this.nptData.columns.length) {
                    this.fetchData()
                }
            }
        }
    }
})
